import { z } from 'zod'
import { DEVICE_LABELS } from './device-value'

export const browserEnvironmentSchema = z.object({
  browserName: z.string(), browserVersion: z.string(), osName: z.string(),
  deviceClass: z.enum(['desktop', 'tablet', 'mobile', 'unknown']), observedAt: z.string(),
})
export type BrowserEnvironment = z.infer<typeof browserEnvironmentSchema>

/** The full call snapshot in surveys and call detail pages. */
export function BrowserEnvironmentValue({ environment }: { environment: BrowserEnvironment | null }): JSX.Element {
  if (!environment) return <span className="text-text-secondary italic">Not recorded</span>
  const device = DEVICE_LABELS[environment.deviceClass]
  return <span className="block break-words">
    <span className="block">{environment.browserName} {environment.browserVersion}</span>
    <span className="block text-text-secondary text-caption">{environment.osName} · {device}</span>
  </span>
}
